import dayjs from 'dayjs';
import Model from '../models/model';
import consts from '../consts';
import util from '../util';
import { dataStore } from '../Store';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}
const { renderBIResultIcon, renderCIResultIcon, renderAttachmentButton, renderBICIEditButton } = util;
const checkIsParametric = () => isparametric()
const model = new Model({
	name: 'SterilizerCycle',
	defaultSort: 'CycleStart DESC',
	disableDelete: true,
	disableAdd: true,
	readOnly: true,
	idProperty: 'SterilizerCycleId',
	formTitleField: 'SterilizerCycleId',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'CycleName', field: 'CycleName', width: 150 },
		{ header: 'CycleCount', field: 'CycleCount', width: 150, type: 'number', align: 'right', headerAlign:'right' },
		{ header: 'SterCycleStatus', field: 'CycleStatus', width: 150 },
		{ header: 'CycleStartDateTime', field: 'CycleStart', width: 200, type: 'dateTime' },
		{ field: 'OperatorName', header: "OperatorName", width: 200, renderCell: ({ row }) => (renderBICIEditButton(row)), align: 'right' },
		{ header: 'Load', field: 'LoadNumber', width: 200},
		{ field: 'BIResult', header: 'BIResult', width: 120, type: 'int', renderCell: ({ row }) => (renderBIResultIcon(row)), excludeOnGrid: checkIsParametric, isNotExportField: true, align:'right', headerAlign:'right'  },
		{ field: 'CIResult', header: 'CIResult', width: 85, type: 'int', renderCell: ({ row }) => (renderCIResultIcon(row, 'CIResultIcon')), excludeOnGrid: checkIsParametric, isNotExportField: true , align:'right', headerAlign:'right' },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row, true)), filterable: false, isNotExportField: true },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 150 },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});
export const NonSterisSteamModel = model;
export default model.createFormBase();
